import Mark from 'mark.js';
import blocksToHtml, { h } from '@sanity/block-content-to-html';
import { GlossaryTerm } from 'superclient';

const BlockRenderer = (props) => {
  return h('p', { className: 's1' }, props.children);
};

export const highlightGlossaryTerms = (
  element?: HTMLDivElement,
  glossaryTerms?: GlossaryTerm[]
) => {
  if (!element || !glossaryTerms) return;

  const instance = new Mark(element);
  const Poppy = require('poppy').default;

  glossaryTerms.forEach((term) => {
    let wePinned = false;
    let setHighlight = false;
    instance.mark(term?.title, {
      accuracy: {
        value: 'exactly',
        limiters: ['!', '.', ',', '’', '-', `'`]
      },
      separateWordSearch: false,
      each: (node) => {
        if (setHighlight) return;
        node.classList.add('highlight');
        const pop = new Poppy({
          target: node,
          onChange: (e) => {
            if (e.pinned === true) {
              pop.popover.addEventListener('mouseenter', () => {
                pop.pin();
                wePinned = true;
              });
              pop.popover.addEventListener('mouseleave', () => {
                pop.unpin();
                wePinned = false;
              });
            }
          },
          popover: `
                <div class='highlight__helper bcw'>
                  <div class='f jcb highlight__helper_wrapper'>
                    <div class='highlight__helper_image' style='background-image: url(${
                      term?.image?.asset.url
                    })'></div>
                    <div class='al p05 f highlight__helper-text jcc ml05'>
                      <h4 class='p0 m0 caps'>${term?.title}</h4>
                      ${blocksToHtml({
                        blocks: term?.description,
                        serializers: { types: { block: BlockRenderer } }
                      })}
                    </div>
                  </div>
                </div>
            `,
          position: 'bottom',
          transitionSpeed: 200
        });
        node.addEventListener('mouseenter', () => {
          wePinned = true;
          pop.pin();
        });
        node.addEventListener('mouseleave', () => {
          setTimeout(() => {
            if (wePinned === true) {
              pop.unpin();
            }
          }, 500);
        });
        setHighlight = true;
      }
    });
  });
};
